const { REACT_APP_ASSETS_URL } = process.env;

export const getAssetURL = (path: string) => `${REACT_APP_ASSETS_URL}/${path}`;
